export enum LocalizationAuthStatus {
  WAITING = 'waiting',
  AUTHORIZED = 'authorized',
  UNAUTHORIZED = 'unauthorized',
  ERROR = 'error',
}

export const LOCALIZATION_AUTH_CACHE_KEY = 'localization_authorized'

export type LocalizationAuthInitialData = {
  code: string
  authorization_url: string
  qr_code_url: string
  expires_in: number
  code_status_poll_interval: number
}

export type LocalizationAuthPollResponse = {
  station_id: string
  status: LocalizationAuthStatus
  [key: string]: any
}

export type UseLocalizePollResult = {
  data: LocalizationAuthPollResponse | null
  error: Error | null
  isPolling: boolean
  isAuthorizationExpired: () => boolean
}

export type LocalizationAuthCache = {
  timestamp: number
  expiresAt: number
  status: LocalizationAuthStatus
  station_id: string
}
